export const MANAGED_SALON_FEATURE_KEYS = [
  "hasOnlineBooking",
  "hasCheckout",
  "hasAiChatbot",
  "hasOnlinePayment",
  "hasVoiceNotes",
  "hasAdvancedReports",
  "hasCommissions",
  "hasPanelChamada",
  "hasMediaPromocional",
  "hasAiWhatsapp",
  "hasAiInstagram",
  "hasBranches",
  "hasFinancial",
  "hasCrm",
  "hasInventory",
  "hasOperations",
  "hasIntelligence",
  "hasAutomation",
  "hasIntegrations",
  "hasAcademy",
  "hasSecurity",
  "hasFiscal",
] as const;

export type ManagedSalonFeatureKey = (typeof MANAGED_SALON_FEATURE_KEYS)[number];

export function buildSalonFeatureUpdate(
  salonId: number,
  _currentFeatures: Record<string, boolean | null>,
  changes: Record<string, boolean>,
  superAdminNotes?: string,
) {
  const payload: Record<string, number | boolean | string | undefined> = { salonId };

  for (const key of MANAGED_SALON_FEATURE_KEYS) {
    if (changes[key] !== undefined) payload[key] = changes[key];
  }

  if (superAdminNotes !== undefined) payload.superAdminNotes = superAdminNotes;
  return payload;
}
